import React, { MouseEventHandler, useCallback } from 'react';
import { UserMembersActionType, UserMembersTranslation } from '../constants';
import { ListBranchItem } from '../types-store';
import { RowSelection } from '../types';
import { ListItemContent } from './user-members-list-item-content';
import { UserMembersItemRow } from 'app/area/subscriber-groups/user-members/components/user-members-item-row';
import styles from './user-members-list-item.scss';

interface UserMembersListItemProps {
  item: ListBranchItem;
  path: number[];
  checked: boolean;
  rowSelected: boolean;
  treeDepthLevel: number;
  isZebra: boolean;
  selectRow: (selection: RowSelection) => void;
  addAction: (path: number[], type: UserMembersActionType, propagate: boolean) => void;
  translation: UserMembersTranslation;
}

export const UserMembersListItem: React.FC<UserMembersListItemProps> = ({
  item, path, checked, rowSelected, treeDepthLevel,
  isZebra, translation, selectRow, addAction
}) => {

  const onSelect = useCallback<MouseEventHandler>((event) => {
    selectRow({
      path,
      append: !!event.ctrlKey,
      range: !!event.shiftKey
    });
  }, [selectRow]);

  return <div className={rowSelected ? styles.rowSelected : styles.row}
    onClick={onSelect}>
    <UserMembersItemRow
      isWarning={!item?.email}
      isZebra={isZebra}
      treeDepthLevel={treeDepthLevel}>
      <ListItemContent
        item={item}
        path={path}
        checked={checked}
        addAction={addAction}
        translation={translation} />
    </UserMembersItemRow>
  </div>;
};
